import { API_URL } from "env";
import { message } from "antd";
import { ProductItem } from "./QuickOrder";

// Định nghĩa kiểu dữ liệu trả về cho Wishlist (cơ bản)
export interface WishlistResponse {
    status: boolean;
    msg: string;
    data?: any;
}

export interface WishlistProductResponse {
    total: number;
    current_page: number;
    items: ProductItem[];
}

async function updateWishlist(productId: number | string): Promise<WishlistResponse> {
    try {
        // 1. Lấy token (giống hàm checkVourcherListProducts)
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No token found');
        }

        const currentIds = await fetchUserWishlistIds();

        const newId = Number(productId);
        let newIdsList: number[] = [];

        if (currentIds.includes(newId)) {
            newIdsList = currentIds.filter(id => id !== newId);
        } else {
            newIdsList = [...currentIds, newId];
        }

        const payload = newIdsList.length > 0 ? newIdsList.join(',') : 0;

        const response = await fetch(`${API_URL}/api/v1/fe/customer/update`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                product_wishlist_id: payload
            }),
        });

        console.log(response);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);
        return data as WishlistResponse;

    } catch (error) {
        console.error('Failed to update wishlist:', error);
        message.error('Lỗi cập nhật danh sách yêu thích');

        // Trả về object lỗi để component không bị crash
        return {
            status: false,
            msg: 'Failed to update wishlist',
        };
    }
}

async function fetchUserWishlistIds(): Promise<number[]> {
    try {
        const token = localStorage.getItem('token');
        if (!token) return [];

        const response = await fetch(`${API_URL}/api/v1/fe/customer/profile`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
            },
        });

        if (!response.ok) return [];

        const res = await response.json();
        const rawData = res?.data?.info?.product_wishlist_id;

        if (!rawData) return [];

        let resultIds: number[] = [];

        // Parse dữ liệu
        if (Array.isArray(rawData)) {
            resultIds = rawData.map(Number);
        } else if (typeof rawData === 'string') {
            if (rawData.trim() === "") return [];

            if (rawData.includes('[')) {
                resultIds = JSON.parse(rawData);
            } else {
                resultIds = rawData.split(',').map(id => Number(id.trim()));
            }
        }

        // ✅ FIX QUAN TRỌNG: Lọc bỏ số 0 và NaN
        return resultIds.filter(id => id !== 0 && !isNaN(id));

    } catch (error) {
        console.error("Lỗi lấy wishlist:", error);
        return [];
    }
};

async function fetchWishlistProducts(page = 1, limit = 10): Promise<WishlistProductResponse | null> {
    try {
        // 1. Lấy IDs trước
        const ids = await fetchUserWishlistIds();

        if (ids.length === 0) {
            return { total: 0, current_page: 1, items: [] };
        }

        const query = new URLSearchParams();
        query.append('page', String(page));
        query.append('limit', String(limit));

        query.append('product_ids', ids.join(','));

        const url = `${API_URL}/api/v1/fe/products?${query.toString()}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) return null;

        const res = await response.json();
        return res.data || res;

    } catch (error) {
        console.error("Lỗi lấy chi tiết wishlist:", error);
        return null;
    }
}

export {
    updateWishlist,
    fetchUserWishlistIds,
    fetchWishlistProducts
}